// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InformesResumenPage_reportLayout__DCRXt {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: calc(100% - 30px);
  margin-top: 10px;
}

.InformesResumenPage_reportCard__yJlUu {
  background-color: #ffffff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 16px 32px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.InformesResumenPage_cardHeader__UBTbW {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.InformesResumenPage_sectionTitle__K9EEt {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 600;
  color: #0f172a;
}

.InformesResumenPage_sectionSubtitle__X4jBm {
  margin: 4px 0 0;
  font-size: 0.92rem;
  color: #6b7280;
  max-width: 520px;
  line-height: 1.45;
}

.InformesResumenPage_metricsGroup__I7Uek {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}

.InformesResumenPage_metricBubble__DOdKx {
  min-width: 140px;
  padding: 12px 16px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.12), rgba(16, 185, 129, 0.04));
}

.InformesResumenPage_metricBubbleAlt__N0pIn {
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.12), rgba(37, 99, 235, 0.04));
}

.InformesResumenPage_metricLabel__Iox\\+h {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 4px;
  color: #047857;
}

.InformesResumenPage_metricBubbleAlt__N0pIn .InformesResumenPage_metricLabel__Iox\\+h {
  color: #1d4ed8;
}

.InformesResumenPage_metricValue__WGiqH {
  font-size: 1.6rem;
  font-weight: 700;
  color: #0f766e;
  margin: 0;
}

.InformesResumenPage_metricBubbleAlt__N0pIn .InformesResumenPage_metricValue__WGiqH {
  color: #1d4ed8;
}

.InformesResumenPage_dropdownContainer__3aBXX {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #f3f4f6;
  border-radius: 12px;
  padding: 8px 12px;
}

.InformesResumenPage_dropdownLabel__oqcBY {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #4b5563;
}

.InformesResumenPage_dropdown__rN7yJ {
  border: none;
  background-color: transparent;
  font-size: 0.95rem;
  font-weight: 600;
  color: #111827;
  outline: none;
  padding: 6px 4px;
  cursor: pointer;
}

.InformesResumenPage_dropdown__rN7yJ:focus {
  outline: 2px solid rgba(37, 99, 235, 0.35);
  border-radius: 6px;
}

.InformesResumenPage_chartContainer__DaPXj {
  width: 100%;
}

.InformesResumenPage_metaInfo__o7Vjv {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 0.8rem;
  color: #6b7280;
  margin-top: 4px;
}

.InformesResumenPage_metaInfoItem__Tacrk {
  display: flex;
  align-items: center;
  gap: 4px;
}

.InformesResumenPage_feedback__OhMf- {
  min-height: 220px;
  border-radius: 12px;
  background-color: #f9fafb;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  font-size: 0.95rem;
  font-weight: 500;
  text-align: center;
  padding: 24px;
}

.InformesResumenPage_feedbackError__D163Z {
  background-color: #fef2f2;
  color: #b91c1c;
}

.InformesResumenPage_errorText__uLf1m {
  color: #b91c1c;
  font-size: 0.82rem;
  margin: 6px 0 0 2px;
}

.InformesResumenPage_dropdown__rN7yJ:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

@media (max-width: 900px) {
  .InformesResumenPage_reportCard__yJlUu {
    padding: 20px;
  }

  .InformesResumenPage_sectionTitle__K9EEt {
    font-size: 1.2rem;
  }

  .InformesResumenPage_metricValue__WGiqH {
    font-size: 1.4rem;
  }
}

@media (max-width: 600px) {
  .InformesResumenPage_reportLayout__DCRXt {
    width: calc(100% - 20px);
  }

  .InformesResumenPage_dropdownContainer__3aBXX {
    width: 100%;
    justify-content: space-between;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/principal/panel/informes/InformesResumenPage.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uFAAuF;AACzF;;AAEA;EACE,qFAAqF;AACvF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;AACF","sourcesContent":[".reportLayout {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: calc(100% - 30px);\n  margin-top: 10px;\n}\n\n.reportCard {\n  background-color: #ffffff;\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 16px 32px rgba(15, 23, 42, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.cardHeader {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.sectionTitle {\n  margin: 0;\n  font-size: 1.35rem;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.sectionSubtitle {\n  margin: 4px 0 0;\n  font-size: 0.92rem;\n  color: #6b7280;\n  max-width: 520px;\n  line-height: 1.45;\n}\n\n.metricsGroup {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n}\n\n.metricBubble {\n  min-width: 140px;\n  padding: 12px 16px;\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(135deg, rgba(16, 185, 129, 0.12), rgba(16, 185, 129, 0.04));\n}\n\n.metricBubbleAlt {\n  background: linear-gradient(135deg, rgba(37, 99, 235, 0.12), rgba(37, 99, 235, 0.04));\n}\n\n.metricLabel {\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  margin-bottom: 4px;\n  color: #047857;\n}\n\n.metricBubbleAlt .metricLabel {\n  color: #1d4ed8;\n}\n\n.metricValue {\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: #0f766e;\n  margin: 0;\n}\n\n.metricBubbleAlt .metricValue {\n  color: #1d4ed8;\n}\n\n.dropdownContainer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background-color: #f3f4f6;\n  border-radius: 12px;\n  padding: 8px 12px;\n}\n\n.dropdownLabel {\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #4b5563;\n}\n\n.dropdown {\n  border: none;\n  background-color: transparent;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #111827;\n  outline: none;\n  padding: 6px 4px;\n  cursor: pointer;\n}\n\n.dropdown:focus {\n  outline: 2px solid rgba(37, 99, 235, 0.35);\n  border-radius: 6px;\n}\n\n.chartContainer {\n  width: 100%;\n}\n\n.metaInfo {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  font-size: 0.8rem;\n  color: #6b7280;\n  margin-top: 4px;\n}\n\n.metaInfoItem {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.feedback {\n  min-height: 220px;\n  border-radius: 12px;\n  background-color: #f9fafb;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6b7280;\n  font-size: 0.95rem;\n  font-weight: 500;\n  text-align: center;\n  padding: 24px;\n}\n\n.feedbackError {\n  background-color: #fef2f2;\n  color: #b91c1c;\n}\n\n.errorText {\n  color: #b91c1c;\n  font-size: 0.82rem;\n  margin: 6px 0 0 2px;\n}\n\n.dropdown:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n@media (max-width: 900px) {\n  .reportCard {\n    padding: 20px;\n  }\n\n  .sectionTitle {\n    font-size: 1.2rem;\n  }\n\n  .metricValue {\n    font-size: 1.4rem;\n  }\n}\n\n@media (max-width: 600px) {\n  .reportLayout {\n    width: calc(100% - 20px);\n  }\n\n  .dropdownContainer {\n    width: 100%;\n    justify-content: space-between;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reportLayout": `InformesResumenPage_reportLayout__DCRXt`,
	"reportCard": `InformesResumenPage_reportCard__yJlUu`,
	"cardHeader": `InformesResumenPage_cardHeader__UBTbW`,
	"sectionTitle": `InformesResumenPage_sectionTitle__K9EEt`,
	"sectionSubtitle": `InformesResumenPage_sectionSubtitle__X4jBm`,
	"metricsGroup": `InformesResumenPage_metricsGroup__I7Uek`,
	"metricBubble": `InformesResumenPage_metricBubble__DOdKx`,
	"metricBubbleAlt": `InformesResumenPage_metricBubbleAlt__N0pIn`,
	"metricLabel": `InformesResumenPage_metricLabel__Iox+h`,
	"metricValue": `InformesResumenPage_metricValue__WGiqH`,
	"dropdownContainer": `InformesResumenPage_dropdownContainer__3aBXX`,
	"dropdownLabel": `InformesResumenPage_dropdownLabel__oqcBY`,
	"dropdown": `InformesResumenPage_dropdown__rN7yJ`,
	"chartContainer": `InformesResumenPage_chartContainer__DaPXj`,
	"metaInfo": `InformesResumenPage_metaInfo__o7Vjv`,
	"metaInfoItem": `InformesResumenPage_metaInfoItem__Tacrk`,
	"feedback": `InformesResumenPage_feedback__OhMf-`,
	"feedbackError": `InformesResumenPage_feedbackError__D163Z`,
	"errorText": `InformesResumenPage_errorText__uLf1m`
};
export default ___CSS_LOADER_EXPORT___;
